export const SELECTED_BOARD_KEY = "selectedBoard";
export const PINNED_BOARDS_KEY = "pinnedBoards";
